import { ReactElement, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Headline5 } from '../../../../components/UI/MDC/Typography/Typography';
import styles from './ApplicationForm.module.scss';

/**
 * Stylized Accordion Summary component
 */

const AccordionSummary = styled(({ expandable, ...props }) => (
	<MuiAccordionSummary
		expandIcon={expandable ? <ExpandLessIcon /> : null}
		{...props}
	/>
))(({ theme }) => ({
	// Purple background, white text, thin black border (same as first but with thin to match better with Box style idea)
	backgroundColor: theme.palette.primary.main,
	borderRadius: '4px',
	color: 'whitesmoke',
	borderColor: 'black',
	borderStyle: 'solid',
	borderWidth: 'thin',

	// expand icon color: white
	'& .MuiAccordionSummary-expandIconWrapper': {
		color: 'whitesmoke',
	},
}));

/**
 * Container component for a form's section
 * @param {Object} props component properties
 * @param {string} props.label form section header text
 * @param {string} props.name name identifier for the element
 * @param {boolean} props.defaultOpen when `true`, the accordion is open upon render
 * @param {ReactElement} props.children the child components to render when appropriate
 * @param {boolean} props.accordion flag to indicate when to render as an accordion
 * @param {object} props.props the rest of the props you pass
 * @returns wrapper component to stylize and organize a form section
 */
const FormSection = ({
	label,
	name,
	defaultOpen = false,
	children,
	accordion,
	...props
}) => {
	const [expanded, setExpanded] = useState(defaultOpen);
	return (
		<Box
			sx={{
				display: 'flex',
				flexBasis: {
					sm: '100%',
					md: props.fullWidth
						? '100%'
						: props.halfWidth
						? '50%'
						: '100%',
				},
				maxWidth: {
					xs: '100%',
					sm: '100%',
					md: props.fullWidth
						? '100%'
						: props.halfWidth
						? '50%'
						: '100%',
				},
				justifyContent: 'flex-start',
				flexDirection: 'column',
			}}
		>
			{accordion ? (
				<Accordion
					expanded={expanded}
					onChange={() => setExpanded(!expanded)}
					id={'accordion_expanded__' + props.id}
				>
					<AccordionSummary expandable>
						<Headline5>{label}</Headline5>
					</AccordionSummary>
					<AccordionDetails
						className={
							styles['application-form__input-indention-1']
						}
					>
						{children}
					</AccordionDetails>
				</Accordion>
			) : (
				<Accordion expanded={true} id={'accordion_static__' + props.id}>
					{label ? (
						<AccordionSummary>
							<Headline5>{label}</Headline5>
						</AccordionSummary>
					) : null}
					<AccordionDetails
						className={
							styles['application-form__input-indention-1']
						}
					>
						{children}
					</AccordionDetails>
				</Accordion>
			)}
		</Box>
	);
};
export default FormSection;
